<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "indexManage"
}
</script>

<style scoped>
</style>
